import { PropsWithChildren, useMemo, useState } from 'react';
import type { StepId, ServerErrors } from 'app/components/core';
import { StepperContext } from './context';

export const StepperProvider = ({ children }: PropsWithChildren) => {
  const [serverErrors, setServerErrors] = useState<ServerErrors>({} as ServerErrors);

  const hasStepError = (id: StepId): boolean =>
    !!serverErrors[id] && Object.values(serverErrors[id] as ServerErrors).some((value) => !!value);

  const providerValue = useMemo(() => {
    return { serverErrors, setServerErrors, hasStepError };
  }, [serverErrors]);

  return <StepperContext.Provider value={providerValue}>{children}</StepperContext.Provider>;
};
